import React, { useState } from "react";
import { useEffect } from "react";
import DummyDashboard from "../../portals/customer/pages/dashboard/DummyDashboard";
import { useSelector } from "react-redux";
import { storeSelector } from "../../redux/slices/storeSlice";
import NewSetPasswordForStoreMemberModal from "./NewSetPasswordForStoreMemberModal";
import { useSearchParams } from "react-router-dom";
import { axiosClient } from "../../api/config/base";

export default function NewSetPassword() {
  const { shopifyAppUserDetails, shopifyAppStore } = useSelector(storeSelector);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [decodedData, setDecodedData] = useState("");

  const getDecodedToken = async () => {
    try {
      const { data } = await axiosClient.post("/store/decode-token", {
        token: token,
      });
      setDecodedData(data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (token) {
      handleOpen();
      getDecodedToken()
    }
  }, [token]);

  console.log("decoded data", decodedData)

  return (
    <>
      <div style={{ visibility: "hidden" }}>
        <NewSetPasswordForStoreMemberModal
          handleOpen={handleOpen}
          handleClose={handleClose}
          open={open}
          setOpen={setOpen}
          userDetails={
            shopifyAppStore?.shop_details
              ? shopifyAppStore
              : shopifyAppUserDetails
          }
          token={token}
          decodedToken={decodedData}
        />
      </div>
      <DummyDashboard storeOwner={"New Member"} />
    </>
  );
}
